module.exports = __webpack_public_path__ + "static/media/nav_02.7923b325.svg";